import React from 'react';
import { Link } from 'react-router-dom';
import './PolicyLayout.css';

interface PolicyLayoutProps {
  title: string;
  lastUpdated: string;
  children: React.ReactNode;
}

const PolicyLayout: React.FC<PolicyLayoutProps> = ({ title, lastUpdated, children }) => {
  return (
    <div className="policy-page">
      <div className="policy-container">
        <nav className="policy-breadcrumb">
          <Link to="/" className="policy-breadcrumb-link">Home</Link>
          <span className="policy-breadcrumb-separator">/</span>
          <Link to="/policies" className="policy-breadcrumb-link">Policies</Link>
          <span className="policy-breadcrumb-separator">/</span>
          <span className="policy-breadcrumb-current">{title}</span>
        </nav>

        <div className="policy-header">
          <h1 className="policy-title">{title}</h1>
          <p className="policy-last-updated">Last updated: {lastUpdated}</p>
        </div>

        <div className="policy-content">
          {children}
        </div>

        <div className="policy-footer">
          <Link to="/policies" className="policy-back-link">
            ← Back to All Policies
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PolicyLayout;
